import {InvoiceOrderStatusTranslationsService} from 'src/app/shared/translations';

/**
 * Blueprint for the sales channel part of ticketing object.
 */
export class TicketingSalesChannel {
  public code: string;
  public description: string;

  public callCenter: string = 'Callcenter';
  public ticketAgent: string = 'Ticketagent';
  public statuses: Array<any> = [
    {
      value: this.callCenter,
      status: this.translations.i18nCallCenter
    },
    {
      value: this.ticketAgent,
      status: this.translations.i18nTicketAgent
    }
  ];

  constructor(data: any, private translations: InvoiceOrderStatusTranslationsService) {
    this.code = data.code;
    this.description = data.description;
   }

   /**
    * This function will translate the sales operator type
    */
  public get translatedSalesOperatorType(): string {
    const translatedPaymentType = this.statuses.find(status => this.description === status.value);
    return translatedPaymentType ? translatedPaymentType.status : this.description;
  }

}
